/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_$x as $x,
  rec_JSXRuntime as JSXRuntime,
  rec_Lx as Lx,
  rec_React as React,
  rec_SelectorMultiple as SelectorMultiple,
  rec_ZC as ZC,
  rec_api as api,
  rec_obtenerUsuario as obtenerUsuario,
} from "../../runtime/index.jsx";
export function NuevoProyecto({
  grupos: e,
  areas: t,
  unidadFija: n,
  onClose: r,
  onCreado: i,
}) {
  let [a, o] = (0, React.useState)(``),
    [s, c] = (0, React.useState)(``),
    [l, u] = (0, React.useState)(() => $x()[0].fondo),
    [f, p] = (0, React.useState)(``),
    [m, h] = (0, React.useState)(``),
    [g, _] = (0, React.useState)(n ? String(n.id) : ``),
    [v, y] = (0, React.useState)(`NINGUNA`),
    [b, x] = (0, React.useState)(``),
    [S, C] = (0, React.useState)(!1);
  async function w(e) {
    if ((e.preventDefault(), !S)) {
      (C(!0), x(``));
      try {
        let e = f || null;
        m.trim() &&
          (e = (
            await api(`/grupos`, {
              method: `POST`,
              body: JSON.stringify({
                nombre: m.trim(),
              }),
            })
          ).id);
        let t = obtenerUsuario();
        (await api(`/proyectos`, {
          method: `POST`,
          body: JSON.stringify({
            nombre: a,
            descripcion: s,
            color: l,
            grupoId: e,
            unidadId: g || null,
            plantilla: v === `NINGUNA` ? null : v,
            propietarioNombre: t?.nombre,
            propietarioCorreo: t?.correo,
          }),
        }),
          i(),
          r());
      } catch (e) {
        (x(e.message), C(!1));
      }
    }
  }
  return (
    <div
      className={`animar-fundido fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4`}
      children={
        <form
          onSubmit={w}
          className={`animar-entrada w-full max-w-md rounded-2xl bg-(--bg) p-6 shadow-2xl`}
          children={[
            <h2
              className={`text-xl font-medium text-(--text-h)`}
              children={`Nuevo proyecto`}
            />,
            <div
              className={`mt-4 flex flex-col gap-3`}
              children={[
                <input
                  className={`rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg)`}
                  placeholder={`Nombre del proyecto`}
                  value={a}
                  onChange={(e) => o(e.target.value)}
                  required={!0}
                  autoFocus={!0}
                />,
                <textarea
                  className={`min-h-20 rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg)`}
                  placeholder={`Descripcion (opcional)`}
                  value={s}
                  onChange={(e) => c(e.target.value)}
                />,
                <div
                  className={`flex flex-wrap gap-2`}
                  children={$x().map((e, t) => (
                    <button
                      key={e.fondo}
                      type={`button`}
                      onClick={() => u(e.fondo)}
                      aria-label={`Color ${t + 1}`}
                      aria-pressed={l === e.fondo}
                      className={`h-7 w-7 rounded-full transition ${l === e.fondo ? `ring-2 ring-(--accent) ring-offset-2 ring-offset-(--bg)` : ``}`}
                      style={{
                        background: e.fondo,
                      }}
                    />
                  ))}
                />,
                <label
                  className={`flex flex-col gap-1 text-xs text-(--text)`}
                  children={[
                    `Grupo (opcional)`,
                    <SelectorMultiple
                      value={f}
                      onChange={(e) => p(e)}
                      placeholder={`— Sin grupo —`}
                      opciones={e.map((e) => ({
                        value: String(e.id),
                        label: e.nombre,
                      }))}
                    />,
                  ]}
                />,
                <input
                  className={`rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-xs text-(--text-h) outline-none focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg)`}
                  placeholder={`…o crea un grupo nuevo escribiendo su nombre aca`}
                  value={m}
                  onChange={(e) => h(e.target.value)}
                />,
                n ? (
                  <p
                    className={`rounded-2xl border border-(--border) bg-(--panel) px-3 py-2 text-xs text-(--text)`}
                    children={[
                      `Se crea dentro de `,
                      <span
                        className={`font-medium text-(--text-h)`}
                        children={n.ruta || n.nombre}
                      />,
                      `.`,
                    ]}
                  />
                ) : t.length > 0 ? (
                  <label
                    className={`flex flex-col gap-1 text-xs text-(--text)`}
                    children={[
                      `Unidad organizacional (opcional) — gerencia, subgerencia, área o grupo de trabajo; define quién manda sobre sus tareas y en qué resumen suma`,
                      <SelectorMultiple
                        value={g}
                        onChange={(e) => _(e)}
                        placeholder={`— Sin asignar —`}
                        opciones={t.map((e) => ({
                          value: String(e.id),
                          label: ZC(e.ruta || e.nombre, e),
                        }))}
                      />,
                    ]}
                  />
                ) : null,
                <label
                  className={`flex flex-col gap-1 text-xs text-(--text)`}
                  children={[
                    `Empezar con una plantilla`,
                    <SelectorMultiple
                      value={v === `NINGUNA` ? `` : v}
                      onChange={(e) => y(e || `NINGUNA`)}
                      placeholder={`En blanco`}
                      opciones={Lx.filter((e) => e.codigo !== `NINGUNA`).map(
                        (e) => ({
                          value: e.codigo,
                          label: e.label,
                        }),
                      )}
                    />,
                  ]}
                />,
              ]}
            />,
            b && <p className={`mt-3 text-sm text-(--error)`} children={b} />,
            <div
              className={`mt-5 flex justify-end gap-2`}
              children={[
                <button
                  type={`button`}
                  onClick={r}
                  className={`rounded-full border border-(--border) px-4 py-2 text-sm text-(--text-h) hover:bg-(--accent-bg)`}
                  children={`Cancelar`}
                />,
                <button
                  type={`submit`}
                  disabled={S}
                  className={`rounded-full bg-(--accent) px-4 py-2 text-sm font-medium text-(--accent-fg) hover:opacity-90 disabled:opacity-50`}
                  children={S ? `Creando…` : `Crear`}
                />,
              ]}
            />,
          ]}
        />
      }
    />
  );
}
